/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Preview_JsonInputs */

const cs_portals_preview_json = /** @type {(inputs: Portals_Preview_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náhled JSON`)
};

const en_portals_preview_json = /** @type {(inputs: Portals_Preview_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview JSON`)
};

/**
* | output |
* | --- |
* | "Preview JSON" |
*
* @param {Portals_Preview_JsonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_preview_json = /** @type {((inputs?: Portals_Preview_JsonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Preview_JsonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_preview_json(inputs)
	return cs_portals_preview_json(inputs)
});